"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _values2 = _interopRequireDefault(require("lodash/values"));
var _replace2 = _interopRequireDefault(require("lodash/replace"));
var _pax = require("../utils/pax.utils");
var _traveller = require("../utils/traveller.utils");
var _constants = require("../constants");
function savedTravellerFactory(_ref) {
  var _traveller$IdType;
  var traveller = _ref.traveller,
    carriers = _ref.carriers,
    flightDate = _ref.flightDate;
  var title = traveller === null || traveller === void 0 ? void 0 : traveller.Title;
  var firstName = traveller === null || traveller === void 0 ? void 0 : traveller.FirstName;
  var middleName = traveller === null || traveller === void 0 ? void 0 : traveller.MiddleName;
  var lastName = traveller === null || traveller === void 0 ? void 0 : traveller.LastName;
  var birthDate = (0, _replace2.default)(traveller === null || traveller === void 0 ? void 0 : traveller.BirthDate, / /g, 'T');
  var idExpiryDate = (0, _replace2.default)(traveller === null || traveller === void 0 ? void 0 : traveller.IdExpiryDate, / /g, 'T');
  var idType = (_traveller$IdType = traveller === null || traveller === void 0 ? void 0 : traveller.IdType) !== null && _traveller$IdType !== void 0 ? _traveller$IdType : _constants.ID_TYPES.PASSPORT;
  idType = (0, _values2.default)(_constants.ID_TYPES).includes(idType) ? idType : _constants.ID_TYPES.PASSPORT;
  return {
    travellerId: traveller === null || traveller === void 0 ? void 0 : traveller._id,
    title: title,
    firstName: firstName,
    middleName: middleName,
    lastName: lastName,
    type: (0, _traveller.getTravellerTypeFromBirthDate)(birthDate, flightDate),
    birthDate: birthDate,
    birthDateIsHijri: (0, _pax.isHijri)(birthDate),
    idExpiryDate: idExpiryDate,
    idExpiryDateIsHijri: (0, _pax.isHijri)(idExpiryDate),
    idType: idType,
    idNumber: traveller === null || traveller === void 0 ? void 0 : traveller.IdNumber,
    issuingCountry: traveller === null || traveller === void 0 ? void 0 : traveller.IdCountryId,
    nationality: traveller === null || traveller === void 0 ? void 0 : traveller.CountryId,
    frequentFlyer: (0, _pax.getFrequentFlyersFromSavedTraveller)({
      traveller: traveller,
      carriers: carriers
    }),
    savedTravellerHash: (0, _traveller.hashSavedTraveller)({
      title: title,
      firstName: firstName,
      middleName: middleName,
      lastName: lastName
    })
  };
}
var _default = exports.default = savedTravellerFactory;